import React from "react";
import Box from "@mui/material/Box";
import SideMenu from "../components/SideMenu/SideMenu";
import Notification from "../components/Notifications/Alert";
import { useTheme } from "@mui/material/styles";

const PrivateLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        backgroundColor: theme.palette.background.paper,
      }}
    >
      {/* The permanent side drawer on the left */}
      <SideMenu />

      {/* Main content area to the right */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        {/* Optional: <AppNavbar /> */}
        {/* Outlet or children for your routes/content */}
        {children}
      </Box>

      {/* Notification sits at the top level so it can be shown for all pages */}
      <Notification />
    </Box>
  );
};

export default PrivateLayout;
